const NotificationActionType = {
  GET_MASS_MESSAGE: 'GET_MASS_MESSAGE',
  GET_MASS_MESSAGE_SUCCESS: 'GET_MASS_MESSAGE_SUCCESS',
  UPDATE_MASS_MESSAGE: 'UPDATE_MASS_MESSAGE',

  MOVE_TO_DRAFT: 'MOVE_TO_DRAFT',

  RESET_MASS_MESSAGE: 'RESET_MASS_MESSAGE',
  RESET_MASS_MESSAGE_RECIPIENTS: 'RESET_MASS_MESSAGE_RECIPIENTS',

  SAVE_MASS_MESSAGES: 'SAVE_MASS_MESSAGES',
  CHANGE_NOTIFICATION_SENT_STATUS: 'CHANGE_NOTIFICATION_SENT_STATUS',

  GET_SENT_MASS_MESSAGES: 'GET_SENT_MASS_MESSAGES',
  GET_SCHEDULED_MASS_MESSAGES: 'GET_SCHEDULED_MASS_MESSAGES',
  GET_DRAFT_MASS_MESSAGES: 'GET_DRAFT_MASS_MESSAGES',
  GET_MASS_MESSAGE_RECIPIENTS: 'GET_MASS_MESSAGE_RECIPIENTS',

  GENERATE_SENT_MASS_MESSAGES: 'GENERATE_SENT_MASS_MESSAGES',
  GENERATE_MASS_MESSAGE_RECIPIENTS: 'GENERATE_MASS_MESSAGE_RECIPIENTS',

  DELETE_MASS_MESSAGE: 'DELETE_MASS_MESSAGE',

  SAVE_MASS_MESSAGES_STATE: 'SAVE_MASS_MESSAGES_STATE',
  SAVE_MESSAGES_TOTAL: 'SAVE_MASS_MESSAGES_TOTAL',
  SAVE_MASS_MESSAGE_RECIPIENTS: 'SAVE_MASS_MESSAGE_RECIPIENTS',

  CHECK_TITLE_EXISTS: 'CHECK_TITLE_EXISTS',
  SAVE_TITLE_EXISTS: 'SAVE_TITLE_EXISTS',

  GET_BONUS_NOTIFICATIONS: 'GET_BONUS_NOTIFICATIONS',
  SAVE_BONUS_NOTIFICATIONS: 'SAVE_BONUS_NOTIFICATIONS',
  RESET_BONUS_NOTIFICATIONS: 'RESET_BONUS_NOTIFICATIONS',

  GET_BONUS_NOTIFICATION: 'GET_BONUS_NOTIFICATION',
  SAVE_BONUS_NOTIFICATION: 'SAVE_BONUS_NOTIFICATION',
  RESET_BONUS_NOTIFICATION: 'RESET_BONUS_NOTIFICATION',
};

export default NotificationActionType;
